import React from "react";
import zoomSdk from "@zoom/appssdk";
import Box from "@amzn/meridian/esm/components/box";
import Card from "@amzn/meridian/esm/components/card";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";

import privacyIcon from "../../images/privacy_icon.svg";
import LogManager from "../utils/LogManager";

const PolicyCard = () => {
  const handlePolicyClick = async () => {
    console.log("Trying open Amazon Policy Page for AiMS...");
    try {
      await zoomSdk.openUrl({
        url: "https://w.amazon.com/bin/view/UnifiedCommunications/MeetingSummaries/AiMS#HPrivacy",
      });
    } catch (error) {
      console.error("Failed to open URL in Zoom:", error);
      LogManager.error("Failed to open URL in Zoom:", error);
    }
  };

  return (
    <Card width="272px" onClick={handlePolicyClick} spacingInset="none">
      <Row spacing="none">
        <Row width="16px" />
        <Column spacing="none" spacingInset="none">
          <Column height="20px" />
          <img src={privacyIcon} alt="wikiIcon" style={{ display: "block", margin: "auto", maxWidth: "100%", height: "auto" }} />
          <Column height="20px" />
        </Column>
        <Row width="16px" />
        <Box spacingInset="none" width="168px">
          <Column spacing="none" spacingInset="none">
            <Column height="16px" />
            <Text fontFamily="amazonEmber" type="h100" alignment="start">
              Amazon policy
            </Text>
            <Column height="8px" />
            <Text fontFamily="amazonEmber" type="b100" color="secondary" alignment="start">
              Understand Amazon policy on using AI in meetings
            </Text>
            <Column height="20px" />
          </Column>
        </Box>
      </Row>
    </Card>
  );
};

export default PolicyCard;
